import { Component, ElementRef, Input, AfterViewInit, ViewChild } from '@angular/core';
import { StringUtils } from '@shared/utils/string.utils';

@Component({
    selector: 'ottimizza-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss']
})
export class TextComponent implements AfterViewInit {

    @Input()
    public briefLimit?: number;

    @Input()
    align: 'center' | 'left' | 'right' | 'justify' = 'left'

    @ViewChild('paragraph', { static: true })
    private el: ElementRef<HTMLSpanElement>;

    private fullText = '';
    public reduced = false;

    ngAfterViewInit(): void {
        this.setText();
    }

    private setText() {
        this.fullText = this.el.nativeElement.innerHTML;
        let text = this.fullText;
        if (this.briefLimit) {
            text = StringUtils.truncate(text, this.briefLimit);
            this.reduced = text.length >= this.briefLimit && text.endsWith('...');
        }
        text = StringUtils.turnIntoHTML(text);
        this.el.nativeElement.innerHTML = text;
    }

    public expand() {
        if (this.reduced) {
            this.briefLimit = 0;
            this.el.nativeElement.innerHTML = this.fullText;
            this.setText();
            this.reduced = false;
        }
    }

}
